export { COUNTRIES } from './countries';

export const API_URL =
    'https://script.google.com/macros/s/AKfycbzGFpI1faEEdvnzp2oN_oytdm31VnnA15DdKNRvcQkijTqbK4M7Gu1i4p9--qx8mZ_d/exec';

export const SAYONARA_PRICE_PER_PERSON = 50;
export const TSHIRT_PRICE = 20;

/** Participation option values sent with registration */
export const PARTICIPATION_CHILDREN_2_DAYS = 'children_2_days';
export const PARTICIPATION_ADULT_2_DAYS = 'adult_2_days';
export const PARTICIPATION_ADULT_3_DAYS = 'adult_3_days';

export const CHILDREN_2_DAYS_PRICE = 30;
export const ADULT_2_DAYS_PRICE = 75;
export const ADULT_3_DAYS_PRICE = 90;
